const options = {
    section: 'free_shipping_bar',
    selector: ".hc-free-shipping-bar"

  }
  const freeShippingBarSelector = document.querySelector(options.selector);

  const getData = () => {
    return fetch(window.Shopify.routes.root + `?sections=${
      options.section
    }`).then(res => res.json()).then(data => {
       const div = document.createElement("div");
      div.innerHTML = data[options.section];
      freeShippingBarSelector.innerHTML = "";
      freeShippingBarSelector.append(div.querySelector(".hc-free-shipping-container"));
    })
  }

  document.addEventListener('page:loaded', function() {
    getData()
  });
  document.addEventListener('cart:updated', function(evt) {
    getData()
  });